export const FETCH_EXTERN_LOGIN_STARTED = 'FETCH/EXTERN/LOGIN/STARTED';
export const FETCH_EXTERN_LOGIN_SUCCESS = 'FETCH/EXTERN/LOGIN/SUCCESS';
export const FETCH_EXTERN_LOGIN_FAILURE = 'FETCH/EXTERN/LOGIN/FAILURE';
